import { render, staticRenderFns } from "./phone-number-field.vue?vue&type=template&id=01d20ee8&scoped=true"
import script from "./phone-number-field.vue?vue&type=script&lang=js"
export * from "./phone-number-field.vue?vue&type=script&lang=js"
import style0 from "./phone-number-field.vue?vue&type=style&index=0&id=01d20ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d20ee8",
  null
  
)

export default component.exports